import { CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { styled } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import type { PropsWithChildren } from 'react';

const iconSX = { marginRight: 8, fontSize: '1.15rem' };

export const Snackbars = ({ children }: PropsWithChildren) =>
    <SnackbarsRoot
        maxSnack={3}
        dense={false}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        iconVariant={{
            success: <CheckCircleOutlined style={iconSX} />,
            error: <CloseCircleOutlined style={iconSX} />,
            warning: <WarningOutlined style={iconSX} />,
            info: <InfoCircleOutlined style={iconSX} />,
        }}
    >
        {children}
    </SnackbarsRoot>;

const SnackbarsRoot = styled(SnackbarProvider)(
    ({ theme }) => ({
        '&.notistack-MuiContent-default': { backgroundColor: theme.palette.primary.main },
        '&.notistack-MuiContent-error': { backgroundColor: theme.palette.error.main },
        '&.notistack-MuiContent-success': { backgroundColor: theme.palette.success.main },
        '&.notistack-MuiContent-info': { backgroundColor: theme.palette.info.main },
        '&.notistack-MuiContent-warning': { backgroundColor: theme.palette.warning.main }
    })
);
